module.exports = __webpack_public_path__ + "static/media/SegundaFranja_Manomoneda2.525dd24f.png";